<template>
<div>
    <v-autocomplete
        hide-no-data
        :search-input.sync="search"
        :items="items"
        :loading="loading"
        v-on:change="handleOnChange"
        return-object
        clearable
        @click:clear="handleOnClear"
        v-model="model"
        v-bind="$props">
    </v-autocomplete>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { searchUsers } from '../../services/administration/user';
import { isEmpty } from 'lodash';

export default {
    name: "UserSearch",
    data() {
        return {
            search: null,
            lastSearch: null,
            loading: false,
            selected: {}
        }
    },
    props: {
        value: {
            type: [String, Number]
        },
        itemText: {
            type: String,
            default: "name"
        },
        itemValue: {
            type: String,
            default: "id"
        },
        label: {
            type: String,
            default: "Search"
        },
        outlined: Boolean,
        hideDetails: Boolean,
        width: String,
        dense: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
            
        }
    },
    computed: {
        ...mapState("administration/user", {
            items: state => state.userSearch
        }),
        found() {
            if (this.search === null) return this.items;
            return this.items.filter(each => this.filter(each, this.search, each[this.itemText]));
        },
        dirty() {
            return this.lastSearch !== this.search;
        },
        model: {
            get() {
                return this.value;
            },
            set(val) {
                let value = !isEmpty(val) ? val.id : null;
                this.$emit("input", value);
            }
        }
    },
    watch: {
        search: {
            handler(search) {
                // empty search
                if (search === null) return;
                // when selected do not fire http.
                if (this.selected[this.itemText] === search) return;
                // has matching record.
                if (this.found.length > 0) return;
                // limit search characters
                if (this.search.trim().length < 3) return;
                // stop firing http if already fired.
                if (this.loading) return;
                // finally call search.
                this.callSearchUsers();
            }
        }
    },
    methods: {
        ...mapActions("administration/user", ["setUsersFromSearch"]),
        handleOnChange(val) {
            if (val === null) return;
            this.$emit("change", this.selected);
            this.selected = val[this.itemText];
        },
        handleOnClear() {
            this.$emit('click:clear');
        },
        callSearchUsers() {
            this.loading = true;
            this.lastSearch = this.search;
            searchUsers({
                    search: this.search
                })
                .then(response => {
                    // this.items = [...this.items, ...response.data];
                    this.setUsersFromSearch(response.data);
                })
                .finally(() => {
                    this.loading = false;
                    if (this.dirty) return this.callSearchUsers();
                });
        },
        filter(item, queryText, itemText) {
            return itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
        }
    }
}
</script>
